import { IAgoraRTCRemoteUser, useRemoteUsers } from "agora-rtc-react";

export type RemoteUser = IAgoraRTCRemoteUser;

export const useAgoraRemoteUsers = (): RemoteUser[] => {
  return useRemoteUsers();
};
